// extracted by mini-css-extract-plugin
export default {"table":"ReferralDocumentsUsedList_table__nASXP"};